const geolocationPositionToJson = (rs) => {
  let coordinatesObject = {
    coords: {
      latitude: rs.coords.latitude,
      longitude: rs.coords.longitude,
      altitude: rs.coords.altitude,
      accuracy: rs.coords.accuracy,
      altitudeAccuracy: rs.coords.altitudeAccuracy,
      heading: rs.coords.heading,
      speed: rs.coords.speed
    },
    timestamp: rs.timestamp
  }
  return coordinatesObject
}

export {geolocationPositionToJson}



// WEBPACK FOOTER //
// ./src/helpers/jsHelpers.js